import App from './App.svelte';
import wasm from '../../wasm/Cargo.toml';
const init = async () => {
    const renderer = await wasm();
    const app = new App({
        target: document.body,
        props: {
            renderer,
        }
    });
};
init();
